module.exports = __webpack_public_path__ + "img/dashmovelogo2.da676afc.png";